import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  message: null,
  loading: false,
  user: {},
  success: false,
  error: false,
  errorMsg: "",
};

const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    registerUserSuccessful(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.success = true;
    },
    registerUserFailed(state, action) {
      state.user = null;
      state.loading = false;
      state.errorMsg = action.payload;
      state.error = true;
    },

    loadingData(state, action) {
      state.loading = action.payload;
    },
  },
});

export const { registerUserSuccessful, registerUserFailed, loadingData } =
  registerSlice.actions;

export default registerSlice.reducer;
